import React from 'react';
/**
 * DjayAvatar part — eyes per emotion.
 * Verbatim extraction of the former `renderEyes()`. Add a new emotion's eye
 * shape by adding a `case` here (and the matching token in `DjayEmotion`).
 */
import type { DjayEmotion } from '../types';
export function Eyes({
  emotion,
  glow = false,
  glowColor = '#FDE68A'
}: {
  emotion: DjayEmotion;
  glow?: boolean;
  glowColor?: string;
}) {
  switch (emotion) {
    case 'sleeping':
      return <g className="djay-eyes" data-id="element-3236">
          <path d="M60 102 Q70 108 80 102" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3237" />
          <path d="M120 102 Q130 108 140 102" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3238" />
        </g>;
    case 'celebrating':
      return <g className="djay-eyes" data-id="element-3239">
          <path d="M60 105 Q70 95 80 105" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3240" />
          <path d="M120 105 Q130 95 140 105" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3241" />
        </g>;
    case 'encouraging':
      return <g className="djay-eyes" data-id="element-3242">
          <path d="M60 100 Q70 95 80 100" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3243" />
          <path d="M120 100 Q130 95 140 100" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3244" />
        </g>;
    case 'proud':
      return <g className="djay-eyes" data-id="element-3245">
          <path d="M60 100 Q70 90 80 100" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3246" />
          <path d="M70 92 L72 96 L76 96 L73 99 L74 103 L70 100 L66 103 L67 99 L64 96 L68 96 Z" fill="#FBBF24" data-id="element-3247" />
          <path d="M120 100 Q130 90 140 100" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3248" />
          <path d="M130 92 L132 96 L136 96 L133 99 L134 103 L130 100 L126 103 L127 99 L124 96 L128 96 Z" fill="#FBBF24" data-id="element-3249" />
        </g>;
    default:
      {
        let pupilXOffset = 0,
          pupilYOffset = 0,
          pupilSize = 3.5,
          showSparkles = true;
        if (emotion === 'thinking') {
          pupilXOffset = 3;
          pupilYOffset = -3;
        } else if (emotion === 'pointing') {
          pupilXOffset = 5;
        } else if (emotion === 'surprised') {
          pupilSize = 2;
          showSparkles = false;
        }
        return <g className="djay-eyes" data-id="element-3250">
          {glow && <g className="djay-eye-glow" aria-hidden="true" data-id="element-3251">
              <circle cx="70" cy="100" r="15" fill={glowColor} fillOpacity="0.5" data-id="element-3252" />
              <circle cx="130" cy="100" r="15" fill={glowColor} fillOpacity="0.5" data-id="element-3253" />
            </g>}
          <ellipse cx="70" cy="100" rx="10" ry="12" fill="white" data-id="element-3254" />
          <ellipse cx={72 + pupilXOffset} cy={102 + pupilYOffset} rx="6" ry="7" fill="#475569" data-id="element-3255" />
          <circle cx={73 + pupilXOffset} cy={103 + pupilYOffset} r={pupilSize} fill="#0F172A" data-id="element-3256" />
          {showSparkles && <circle cx={76 + pupilXOffset} cy={99 + pupilYOffset} r={emotion === 'excited' ? 3.5 : 2.5} fill="white" data-id="element-3257" />}
          {showSparkles && <circle cx={69 + pupilXOffset} cy={105 + pupilYOffset} r="1" fill="white" fillOpacity="0.7" data-id="element-3258" />}
          <ellipse cx="130" cy="100" rx="10" ry="12" fill="white" data-id="element-3259" />
          <ellipse cx={132 + pupilXOffset} cy={102 + pupilYOffset} rx="6" ry="7" fill="#475569" data-id="element-3260" />
          <circle cx={133 + pupilXOffset} cy={103 + pupilYOffset} r={pupilSize} fill="#0F172A" data-id="element-3261" />
          {showSparkles && <circle cx={136 + pupilXOffset} cy={99 + pupilYOffset} r={emotion === 'excited' ? 3.5 : 2.5} fill="white" data-id="element-3262" />}
          {showSparkles && <circle cx={129 + pupilXOffset} cy={105 + pupilYOffset} r="1" fill="white" fillOpacity="0.7" data-id="element-3263" />}
        </g>;
      }
  }
}